document.addEventListener('DOMContentLoaded', () => {
	// Function to update the value
	function updateValue( input, delta ) {
		let newValue = parseInt( input.value ) + delta;
		if( newValue < 1 ) {
			newValue = 1;
		}
		input.setAttribute( 'value', newValue );
		input.value = newValue;
		
		input.dispatchEvent( new Event( 'input', {
			"bubbles": true
		} ) );
	}

	// Get all the input groups
	const inputGroups = document.querySelectorAll( '.input-group' );
	
	// Iterate over each input group
	inputGroups.forEach( ( group ) => {
		const decrementButton = group.querySelector( '.decrement' );
		const incrementButton = group.querySelector( '.increment' );
		const inputField = group.querySelector( 'input[type=number]' );
		
		// Decrement event
		decrementButton.addEventListener( 'click', () => updateValue( inputField, -1 ) );

		// Increment event
		incrementButton.addEventListener( 'click', () => updateValue( inputField, 1 ) );
	} );
} );